// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1AsqX","container":"styles_container__37gOz","title":"styles_title__3IcY2","wrapper":"styles_wrapper__3-99T","answer":"styles_answer__3BDY0"};